import * as React from 'react'

interface IIcon {
  icon:
    | 'start'
    | 'company'
    | 'clients'
    | 'invoice'
    | 'edit'
    | 'image'
    | 'chart'
    | 'view'
    | 'add'
    | 'remove'
    | 'print'
}

const Icon: React.SFC<IIcon> = props => (
  <img src={require(`../../assets/${props.icon}.png`)} />
)

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.tsx